export const ID = "taskId";
export const CATEGORY = "categoryId";
export const SUB_CATEGORY = "subCategoryId";
export const TASK_NAME = "taskName";
export const PLANNED_START_DATE = "plannedStartDate";
export const PLANNED_END_DATE = "plannedEndDate";
export const DAYS = "plannedDurationDays";
export const SAFETY_CHECK = "requiresSafetyCheck";
export const QUALITY_CHECK = "requiresQualityCheck";
export const QUALITY_CHECKLIST = "qualityChecklist";
export const DEPS = "dependencies";

export const checklistOption = [
  { label: "Opt 1", value: "opt_1" },
  { label: "Opt 2", value: "opt_2" },
  { label: "Opt 3", value: "opt_3" },
  { label: "Opt 4", value: "opt_4" },
  { label: "Opt 5", value: "opt_5" },
  { label: "Opt 6", value: "opt_6" },
];

export const depsTypes = {
  FINISH_TO_FINISH: "FF",
  FINISH_TO_START: "FS",
  START_TO_FINISH: "SF",
  START_TO_START: "SS",
}